// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");

function fromInt(screenWidth) {
  if (Curry._2(Relude_Int.compare, screenWidth, 481) === "less_than") {
    return /* Mobile */0;
  } else if (Curry._2(Relude_Int.compare, screenWidth, 1025) === "less_than") {
    return /* Tablet */1;
  } else {
    return /* Desktop */2;
  }
}

function compare(a, b) {
  switch (a) {
    case /* Mobile */0 :
        if (b !== 0) {
          return "less_than";
        } else {
          return "equal_to";
        }
    case /* Tablet */1 :
        switch (b) {
          case /* Mobile */0 :
              return "greater_than";
          case /* Tablet */1 :
              return "equal_to";
          case /* Desktop */2 :
              return "less_than";
          
        }
    case /* Desktop */2 :
        if (b >= 2) {
          return "equal_to";
        } else {
          return "greater_than";
        }
    
  }
}

function eq(a, b) {
  return compare(a, b) === "equal_to";
}

exports.fromInt = fromInt;
exports.compare = compare;
exports.eq = eq;
/* Relude_Int Not a pure module */
